import TextableModel from '../TextableModel';
import PropertyDescriptor from '../../utils/PropertyDescriptor';

export default class Model extends TextableModel {

    href = new PropertyDescriptor("", '超链接', "行为", "text", "#anticon-link", {
        placeholder: '请输入一个链接地址'
    });

    target = new PropertyDescriptor("_blank", '目标容器', "行为", "enum", "#anticon-chuangkou", {
        placeholder: '请选择',
        description: "该参数指定在什么窗口中打开超链接的地址",
        catalogIndex: 20,
        values: [
            new PropertyDescriptor("_blank", '新窗口', "目标容器", "string"),
            new PropertyDescriptor("_self", '当前窗口', "目标容器", "string"),
        ]
    });

    constructor(opts = {}) {
        super();
        this.defineAllProperties();

        this.backgroundColor = "transparent";
        this.borderWidth = 0;
        this.text = "超链接";

        for (var p in opts) {
            this[p] = opts[p];
        }
    }

    getType() {
        return "LinkModel";
    }

    toStyle() {


        return {
            ...super.toStyle(),
            borderRadius: 0,
            ...super.getExtendStyle(),
        }
    }
}
